'use client';

import Layout from '@component/common/layout/Layout';
import QnAWrapper from '@component/qna/QnAWrapper';
import ResumeUpdatePage from '@component/resume/ResumeUpdatePage';
import { useQueryGetJD, useQueryGetJDViewSetting } from '@queries/position';
import { channelTalkActiveStatusAtom } from '@recoil/channelTalkActiveStatusAtom';
import { viewModeAtom } from '@recoil/viewAtom';
import classNames from 'classnames/bind';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import Button from 'ui/common/button/Button';
import TopButton from 'ui/component/page/TopButton';
import JDContent from 'ui/component/recruiter/JD/JDContent';
import Modal from 'ui/context/modal/Modal';
import { SOLUTION_TYPE } from 'ui/util/solution';
import style from './JD.module.scss';
import { brandColorAtom } from '@recoil/brandColor/brandColor.atom';

const cx = classNames.bind(style);

interface IJobsIdProps {
  params: {
    id: number;
  };
}

const JD = ({ params }: IJobsIdProps) => {
  const searchParams = useSearchParams();
  const [viewMode] = useRecoilState(viewModeAtom);
  const channelTalkActiveStatus = useRecoilValue(channelTalkActiveStatusAtom);
  const [openModal, setOpenModal] = useState(false);
  const { data: queryGetJDData } = useQueryGetJD[SOLUTION_TYPE]({ positionSn: params.id });
  const { data: queryGetJDViewSettingData } = useQueryGetJDViewSetting[SOLUTION_TYPE]({ positionSn: params.id });
  const viewType = searchParams.get('viewType');
  const brandColor = useRecoilValue(brandColorAtom);
  if (!queryGetJDData) return null;

  const apply = async () => {
    const { submissionStatus } = queryGetJDData;
    if (submissionStatus && submissionStatus === 'POST_SUBMISSION') {
      handleClickOpenModal();
      return;
    }

    const { applyUrl } = queryGetJDData;
    window.open(applyUrl, '_blank');
  };

  const handleClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleClickCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Layout>
      {viewType === 'QnA' ? (
        <QnAWrapper viewMode={viewMode} />
      ) : viewType === 'ResumeUpdate' ? (
        <ResumeUpdatePage viewMode={viewMode} />
      ) : (
        <>
          <div className={cx('content')}>
            <div className={cx('content-wrapper', viewMode)}>
              <JDContent
                params={params}
                viewMode={viewMode}
                data={queryGetJDData}
                brandColor={brandColor!}
                viewSettingData={queryGetJDViewSettingData}
                handleClickApply={apply}
              />
            </div>
          </div>
          <Modal show={openModal} close={handleClickCloseModal}>
            <div className={cx('confirm-modal-wrapper', viewMode)}>
              <h3>모든 채용 전형이{'\n'}종료된 포지션입니다.</h3>
              <p className={cx('content')}>종료된 포지션은 지원할 수 없습니다.</p>
              <div className={cx('footer')}>
                <Button className={cx('button')} size={'md'} onClick={handleClickCloseModal}>
                  확인
                </Button>
              </div>
            </div>
          </Modal>
        </>
      )}
      <TopButton needMovePosition={channelTalkActiveStatus} />
    </Layout>
  );
};
export default JD;
